export default __webpack_public_path__ + "static/media/MATHEMATICS_CALCULUS.5e94fad2.svg";